import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NewbuildingsFromDeveloper.css';

export interface INewbuildingsFromDeveloperProps {
  showAllLink: React.ReactNode;
}

const NewbuildingsFromDeveloperComponent: React.ForwardRefRenderFunction<
  HTMLDivElement,
  React.PropsWithChildren<INewbuildingsFromDeveloperProps>
> = (props, ref) => {
  const { children, showAllLink } = props;

  return (
    <section className={styles['container_redesigned']} ref={ref}>
      <div className={styles['title']}>
        <UIHeading1 as="h3">Другие жилые комплексы от застройщика</UIHeading1>
      </div>

      {children}

      <div className={styles['link']}>{showAllLink}</div>
    </section>
  );
};

export const NewbuildingsFromDeveloper = React.forwardRef(NewbuildingsFromDeveloperComponent);
